import { OmniHeroesCommunity } from "@/types";
import Base64 from "base-64";

export function getStoreItem(key: string) {
  return localStorage.getItem(key);
}

export function setStoreItem(key: string, value: string) {
  return localStorage.setItem(key, value);
}

export function getUserInfo() {
  const data = sessionStorage.getItem("user") || "";
  try {
    const user = Base64.decode(data);
    return JSON.parse(user);
  } catch (e) {
    return undefined;
  }
}

export function removeUserInfo() {
  return sessionStorage.removeItem("user");
}

export function setUserInfo(userInfo?: OmniHeroesCommunity.UserInfo) {
  try {
    sessionStorage.setItem(
      "user",
      Base64.encode(JSON.stringify(userInfo || {}))
    );
  } catch (e) {}
}

export function getUrlParmas(key: string) {
  const urlParam = (window.location.search || "").substring(1);
  let paramArray: { [key: string]: string } = {};
  urlParam.split("&").forEach((mapItem) => {
    const paramItem = mapItem.split("=");
    if (paramItem[0]) {
      paramArray[paramItem[0]] = paramItem[1] || "";
    }
  });
  return paramArray[key];
}

var utf8to16 = function (str: string) {
  var out, i, len, c;
  var char2, char3;
  out = "";
  len = str.length;
  i = 0;
  while (i < len) {
    c = str.charCodeAt(i++);
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        // 0xxxxxxx
        case7: out += str.charAt(i - 1);
        break;
      case 12:
      case 13:
        // 110x xxxx 10xx xxxx
        char2 = str.charCodeAt(i++);
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        // 1110 xxxx 10xx xxxx 10xx xxxx
        char2 = str.charCodeAt(i++);
        char3 = str.charCodeAt(i++);
        out += String.fromCharCode(
          ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
        );
        break;
    }
  }
  return out;
};

export function getGameId() {
  if (sessionStorage.getItem("language") == "tw") {
    return 2000008;
  }
  return 2000000;
}

let urlParam = getUrlParmas("params");
try {
  if (urlParam) {
    // todo 处理base64 ios转义 / + =
    const yl = urlParam.length % 4;
    if (yl != 0) {
      urlParam =
        urlParam +
        Array.from({ length: 4 - yl })
          .map((mapItem) => "=")
          .join("");
    }
    urlParam = urlParam.replace(/_/g, "/").replace(/-/g, "+");
    //todo 传递得编码格式为utf-16 需要转换为 utf-8
    let d = decodeURIComponent(
      Base64.decode(urlParam)
        .split("")
        .map((mapItem) => {
          return "%" + ("00" + mapItem.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    let paramArray: any = {};
    d.split("&").forEach((mapItem) => {
      const paramItem = mapItem.split("=");
      if (paramItem[0]) {
        paramArray[paramItem[0]] = paramItem[1] || "";
      }
    });
    let urlLanguage = paramArray["language"] || "en";
    // 如果是台包 只显示繁中
    if (paramArray["appid"] == 15 || paramArray["appid"] == 18) {
      urlLanguage = "tw";
    }
    sessionStorage.setItem("appid", paramArray["appid"] || "");
    sessionStorage.setItem("uid", paramArray["uid"] || "");
    sessionStorage.setItem("roleid", paramArray["roleid"] || "");
    sessionStorage.setItem("roleName", paramArray["roleName"] || "");
    sessionStorage.setItem("serverName", paramArray["serverName"] || "");
    sessionStorage.setItem("serverid", paramArray["serverid"] || "");
    sessionStorage.setItem("deviceOS", paramArray["deviceOS"] || "");
    sessionStorage.setItem("version", paramArray["version"] || "");
    sessionStorage.setItem("ip", paramArray["ip"] || "");
    sessionStorage.setItem("language", (urlLanguage || '').toLocaleLowerCase());
    // sessionStorage.setItem('language', 'en')
    sessionStorage.setItem("vipLevel", paramArray["vipLevel"] || "");
  }
  if (getUrlParmas("from")) {
    sessionStorage.setItem("language", getUrlParmas("from"));
  }

  if (sessionStorage.getItem("language") == "tw") {
    document.title = "女武神契約論壇";
    const des = document.querySelector('meta[name="description"]');
    if (des) {
      des.setAttribute(
        "content",
        "《女武神契約》是一款英雄魔幻题材的靈活策略卡牌RPG遊戲。親愛的守護者，帕爾馬洛斯需要你來拯救！在輕暗黑世界，拯救遭惡魔囚禁的女武神，與她們共同對抗威脅世界的強敵！"
      );
    }
  }
} catch (e) {
  console.error(e);
}
